import { BMPrimitives } from "@traveloka/district-bloom";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { StyleSheet } from "react-native";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { BMDrawer } from "../../BMDrawer";
import DisableTravelerPickerProvider from "../Provider/DisableTravelerPickerContext";
import TravelerPickerErrorHandler from "../TravelerPickerErrorHandler";
import SelectEmployeeDrawerAllEmployee from "./SelectEmployeeDrawerAllEmployee";
import SelectEmployeeDrawerHeader from "./SelectEmployeeDrawerHeader";
import SelectEmployeeDrawerRecentPick from "./SelectEmployeeDrawerRecentPick";
import { SelectEmployeeFormValues } from "./types";

type Props = {
  isVisible: boolean;
  initialEmployeeList?: SelectEmployeeFormValues["selectedEmployees"];
  onClose(): void;
  onSubmit(values: SelectEmployeeFormValues): void;
  nonEmployeeAdults: number;
  nonEmployeeChildren: number;
};

export default function SelectEmployeeDrawer(props: Props) {
  const {
    initialEmployeeList,
    isVisible,
    onClose,
    onSubmit,
    nonEmployeeAdults,
    nonEmployeeChildren,
  } = props;

  const { CorporateTravelerPicker: cr } = useMobileContentResource();

  const methods = useForm<SelectEmployeeFormValues>({
    defaultValues: {
      selectedEmployees: initialEmployeeList || [],
      searchEmployee: "",
      divisions: [],
    },
  });
  const {
    control,
    formState: { isDirty },
    handleSubmit,
  } = methods;

  const selectedEmployees = useWatch({
    control,
    name: "selectedEmployees",
  });

  function handleSubmitButton(values: SelectEmployeeFormValues) {
    onSubmit(values);
    onClose();
  }

  return (
    <BMDrawer
      headerNavigationProps={{
        onBackActionPress: onClose,
        title: cr.selectEmployeeTitle,
      }}
      footerButtonProps={{
        onPress: handleSubmit(handleSubmitButton),
        label: cr.selectEmployeeSubmitButtonText,
        disabled: !isDirty,
      }}
      show={isVisible}
      variant="COMPACT"
    >
      <TravelerPickerErrorHandler name={["selectedEmployees"]} {...methods} />
      <DisableTravelerPickerProvider
        nonEmployeeAdults={nonEmployeeAdults}
        nonEmployeeChildren={nonEmployeeChildren}
        employees={selectedEmployees}
      >
        <FormProvider {...methods}>
          <BMView style={styles.container}>
            <SelectEmployeeDrawerHeader />
            <SelectEmployeeDrawerRecentPick />
            <SelectEmployeeDrawerAllEmployee />
          </BMView>
        </FormProvider>
      </DisableTravelerPickerProvider>
    </BMDrawer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: BMPrimitives.BMSize.md,
    paddingTop: BMPrimitives.BMSize.lg,
  },
});
